import { axios } from "@/lib/axios";

import { MeAuthorizationResponse } from "../types";

export const getMeAuthorization =
  async (): Promise<MeAuthorizationResponse> => {
    return await axios.get("/authorization/me");
  };
